export const webTheme = {
  _version: 'theme',
  section: {
    title: {
      fontSize: '24px',
    },
    content: {
      fontSize: '14px',
    },
    colors: {
      primary: '#0070f3',
    },
  },
}

export const mobileTheme: ITheme = {
  _version: 'theme',
  section: {
    title: {
      fontSize: '14px',
    },
    content: {
      fontSize: '12px',
    },
    colors: {
      primary: '#0070f3',
    },
  },
}
export type ITheme = typeof webTheme
